import { gql } from "@apollo/client"

// CheckoutType is a string that is either "rental" or "leasing"
export type CheckoutType = "rental" | "leasing" | "direct" | undefined

export const CREATE_UNPAID_ORDER = gql`
  mutation createOrder($email: String!, $checkoutId: String!, $checkoutType: String!) {
    createOrder(email: $email, checkoutId: $checkoutId, checkoutType: $checkoutType) {
      order {
        id
      }
    }
  }
`
